import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IProviderInfoDto, IUpdateProviderDto } from '@/dtos';

export type UpdateProviderDto = Partial<IUpdateProviderDto> & { providerId: string };
export type UpdatedProviderDto = Pick<IProviderInfoDto, 'id' | 'facility_name'>;

const useUpdateProviderQuery = () => {
  const { mutateAsync } = useMutation((providerDto: UpdateProviderDto) =>
    api.put<UpdatedProviderDto>(API_URL.PROVIDERS_BY_ID(providerDto?.providerId), {
      facility_name: providerDto?.facility_name,
      ...providerDto?.addresses?.length ? { addresses: providerDto?.addresses }: {},
    })
  );

  const updateProvider = useCallback(async (providerDto: UpdateProviderDto): Promise<UpdatedProviderDto> => {
    const response = await mutateAsync(providerDto);
    return response.data;
  }, [mutateAsync]);

  return {
    updateProvider,
  };
};

export default useUpdateProviderQuery;
